<script>
import {getPlaylists} from "@/api/playlist/func";
export default {
  name: "EditSchedule",
  data(){
    return {
      playlists:[],
      getPlaylists: getPlaylists,
      taskName:"",
      choosenPlaylist:null,
    }
  },
  methods:{
    async getListPlaylists(){
      this.playlists = await this.getPlaylists()
      console.log(`Playlists: ${this.playlists}`)

    },
    addTask(){
      this.$emit('create-task')
    }
  },
  mounted() {
    this.getListPlaylists()
  }
}
</script>

<template>
<div class="edit-schedule-container">
  <div class="edit-schedule">
    <h4>Новая задача</h4>
    <div class="edit-schedule-form">
      <div class="edit-schedule-item">
        <span>Название задачи</span>
        <input v-model="taskName">
      </div>
      <div class="edit-schedule-item">
        <span>Выберите плейлист</span>
        <select v-model="choosenPlaylist">
          <option  v-for="playlist in playlists" :value="playlist.id">{{playlist.name}}</option>
        </select>
      </div>
    </div>
    <button>Сохранить</button>
  </div>
</div>
</template>

<style scoped>
.active{
  display: block;
  transition: all 5s ease-in-out;
}
.hidden{
  display: none;
}
.edit-schedule-container{
  position:fixed;
  display: flex;
  align-items: center;
  flex-direction: column;
}
.edit-schedule{
  padding-top:20px;
  padding-left:10px;
  padding-right:10px;
  padding-bottom:20px;
  transition: all 0.2s ease;
  border: 1px solid gray;
  border-radius: 12px;
  display: flex;
  align-self: center;
  position:static;
  top:50%;
  flex-direction: column;
  width:240px;
  height: 60%;
  margin-right:15px;
}
.edit-schedule-form{
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
  row-gap:30px;
}
.edit-schedule-item{
  display: flex;
  flex-direction: column;
}
.image-container{
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.edit-button{
  color: #fff;
  background-color: #0d6efd;
  border-color: #0d6efd;
  border: 1px solid transparent;
  border-radius:0.25rem;
  cursor:pointer;
  padding: .375rem .75rem;
  font-size:1rem;
  transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
.edit-button:hover{
  background-color: #aad2fc;
}
</style>